<template>
  <div>
    <!-- if this is active route (e.g. /endusers) -->
    <template v-if="isCurrentRoute">
      <h2>{{ $t('views.endusers.addresses.title') }}</h2>

      <section v-for="section in endUserSections" :key="section.endUserId" class="mb-4">
        <b-row class="mb-2" align-h="between" align-v="center">
          <b-col>
            <h3 class="mb-0">Tenant {{ section.tenantName }}</h3>
          </b-col>
          <b-col cols="auto">
            <b-button
              variant="outline-primary"
              @click="goAdd(section.endUserId)"
            >
              <b-icon icon="plus"/> {{ $t('views.endusers.addresses.button.addaddress') }}
            </b-button>
          </b-col>
        </b-row>

        <b-table
          :busy="isLoading"
          :fields="tableFields"
          :items="addressesFor(section.endUserId)"
          striped
          hover
          show-empty
          sort-icon-left
          @row-clicked="row => goDetail(section.endUserId, row)"
        >
          <template #table-busy>
            <div class="text-center">
              <loader type="dots" inline scale="4" />
              <div>{{ $t('components.table.busy') }}</div>
            </div>
          </template>

          <template #cell(type)="data">
            <b-badge variant="dark">{{ data.value }}</b-badge>
          </template>

          <template #empty>
            <div class="text-center">{{ $t('components.table.empty') }}</div>
          </template>
        </b-table>
      </section>
    </template>

    <!-- if subroute is active route (e.g. /endusers/detail) -->
    <section v-else>
      <router-view/>
    </section>
  </div>
</template>

<script>
import MixinEntityBase from '@/components/mixins/EntityBase'
import Loader from '@/components/Loader'
import MixinEndUserSections from '@/views/EndUsers/_mixins/endUserSections'

const ENTITY_KEY = 'enduseraddresses'

export default {
  name: 'EndUsers.Addresses',
  mixins: [MixinEntityBase, MixinEndUserSections],
  components: {
    Loader
  },
  data () {
    return {
      entityKey: ENTITY_KEY,
      tableFields: [
        { key: 'type', label: this.$t('views.endusers.addresses.table.label.type'), sortable: true },
        { key: 'street', label: this.$t('views.endusers.addresses.table.label.street'), sortable: true },
        { key: 'zip', label: this.$t('views.endusers.addresses.table.label.zip'), sortable: true },
        { key: 'city', label: this.$t('views.endusers.addresses.table.label.city'), sortable: true },
        { key: 'canton', label: this.$t('views.endusers.addresses.table.label.canton'), sortable: true },
        { key: 'country', label: this.$t('views.endusers.addresses.table.label.country'), sortable: true },
        { key: 'status', label: this.$t('views.endusers.addresses.table.label.status'), sortable: true, class: 'cell-align-right' }
      ]
    }
  },
  computed: {
    is () {
      return this.$store.getters[`${ENTITY_KEY}/is`]
    },
    isLoading () {
      return this.is.loading
    },
    isCurrentRoute () {
      return Object.values(this.$route.matched[this.$route.matched.length - 1].components).find(c => c.name === this.$options.name) !== undefined
    }
  },
  methods: {
    addressesFor (endUserId) {
      return this.$store.getters[`${ENTITY_KEY}/getUnwrappedByEndUserId`](endUserId) || []
    },
    getAddresses (endUserId) {
      return this.$store.dispatch(`${ENTITY_KEY}/getAll`, { by: { name: 'EndUser', id: endUserId } })
    },
    goAdd (endUserId) {
      this.$router.push({
        name: 'EndUsers.Addresses.Add',
        params: {
          enduserid: this.endCustomerId,
          endUserId
        }
      })
    },
    goDetail (endUserId, address) {
      if (!address || !address.id) return
      this.$router.push({
        name: 'EndUsers.Addresses.Detail',
        params: {
          enduserid: this.endCustomerId,
          endUserId,
          enduseraddressid: address.id
        }
      })
    }
  },
  created () {
    this.$watch('endUserSections', sections => {
      (sections || []).forEach(s => this.getAddresses(s.endUserId))
    }, { immediate: true })
  }
}
</script>

<style lang="scss"></style>

